import React from 'react';
import { useAdyenSCA } from './adyen_sca_hook';
import type { PaymentAction as LegacyPaymentAction } from '@adyen/adyen-web/dist/types/types';
import type { PaymentAction as V6PaymentAction } from '@adyen/adyen-web-v6';

interface Props {
  action: LegacyPaymentAction | V6PaymentAction;
}

export default function SCARedirectShopper({ action }: Props) {
  useAdyenSCA({ selector: '[data-3ds-redirect-shopper]', action, onAdditionalDetails });

  return <div data-3ds-redirect-shopper />;
}

function onAdditionalDetails() {} // Additional details for the Redirect are handled in a browser POST
